<template>
  <v-container>
    <v-card class="mx-auto pa-4">
      <p class="display-1 text--primary">Excluded Listings</p>
      <p class="text--secondary">
        These marketplace items are excluded from every current and future snapshot. Removing an exclusion recalculates
        the latest snapshot for each CatCode that contains the item.
      </p>
      <v-text-field v-model="searchText" label="Search by title, seller, item ID, or reason" prepend-inner-icon="mdi-magnify" clearable hide-details />
      <v-data-table :headers="headers" :items="items" :loading="loading" loading-text="Loading...please wait"
        class="elevation-1 mt-4" :options.sync="options" :server-items-length="totalItems" :footer-props="{
          itemsPerPageOptions: [10, 20, 100, 500, -1]
        }">
        <template v-slot:item.title="{ item }">
          <a v-if="item.url" :href="item.url" target="_blank">{{ item.title }}</a>
          <span v-else>{{ item.title }}</span>
        </template>
        <template v-slot:item.excludedDateTime="{ item }">
          {{ new Date(item.excludedDateTime).toLocaleString() }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn color="success" small @click="removeExclusion(item)" :loading="removingId === item.id">
            Include
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <ConfirmationDialog ref="confirm" />
  </v-container>
</template>

<script>
import { ListingsService } from '../services/api/listings';
const apiListings = new ListingsService();

export default {
  name: 'ExcludedListings',
  components: {
    ConfirmationDialog: () => import("../components/confirmation-dialog")
  },
  data() {
    return {
      items: [],
      loading: false,
      removingId: null,
      totalItems: 0,
      searchText: '',
      searchTimeout: null,
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: ['excludedDateTime'],
        sortDesc: [true],
      },
      headers: [
        { text: 'Title', value: 'title' },
        { text: 'Seller', value: 'sellerUserID' },
        { text: 'Item ID', value: 'marketplaceItemID' },
        { text: 'Reason', value: 'reason' },
        { text: 'Excluded By', value: 'excludedBy' },
        { text: 'Excluded', value: 'excludedDateTime' },
        { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.fetchItems();
      },
      deep: true,
    },
    searchText() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        if (this.options.page !== 1) {
          this.options = { ...this.options, page: 1 };
        } else {
          this.fetchItems();
        }
      }, 500);
    },
  },
  methods: {
    async fetchItems() {
      this.loading = true;
      try {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        const result = await apiListings.getExcludedListings({
          searchText: this.searchText || undefined,
          sortOrderField: sortBy.length ? sortBy[0] : 'excludedDateTime',
          sortDirection: sortDesc.length && sortDesc[0] ? 'desc' : 'asc',
          itemsPerPage,
          itemsToSkip: itemsPerPage > 0 ? (page - 1) * itemsPerPage : 0,
        });
        this.items = (result && Array.isArray(result.items)) ? result.items : [];
        this.totalItems = result ? result.totalItemCount : 0;
      } finally {
        this.loading = false;
      }
    },
    async removeExclusion(item) {
      if (!await this.$refs.confirm.open(
        "Include Listing",
        `Include '${item.title}' in snapshots again?`,
        { okText: "Include", okColor: "success" })) {
        return;
      }

      this.removingId = item.id;
      try {
        await apiListings.deleteExclusion(item.id);
        this.fetchItems();
      } finally {
        this.removingId = null;
      }
    },
  },
  mounted() {
    this.fetchItems();
  },
};
</script>
